import React, { useState } from 'react'
import { useAuth } from 'react-oidc-context'
import Button from '../Button/Button'
import { logger } from '../../../utils'

interface SSOButtonProps {
  id?: string
  'data-testid'?: string
  disabled?: boolean
  className?: string
}

const SSOButton: React.FC<SSOButtonProps> = ({
  id,
  'data-testid': dataTestId,
  disabled = false,
  className = ''
}) => {
  const auth = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  const handleSSOLogin = async (): Promise<void> => {
    try {
      setIsLoading(true)

      // Initiate the SSO login flow
      await auth.signinRedirect({
        extraQueryParams: {
          prompt: 'login' // Force fresh authentication
        }
      })
    } catch (error) {
      logger.error('SSO authentication failed:')
      logger.error(error as any)
      setIsLoading(false)
      // Error handling is managed by the OIDC context
    }
  }

  return (
    <Button
      id={id}
      data-testid={dataTestId}
      className={`h-[86px] w-full diamond-btn font-bold flex justify-center items-center bg-dopage-primary ${className}`}
      disabled={disabled || isLoading || auth.isLoading}
      loading={isLoading || auth.isLoading}
      onClick={() => { void handleSSOLogin() }}
      type='button'
    >
      <span className='text-black text-[26px]'>
        Continue with SSO
      </span>
    </Button>
  )
}

export { SSOButton }
